import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, navigate } from "gatsby";
import logo from "../images/logo.svg";
import { Transition, animated } from "react-spring";
import "./header.scss";

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deferredPrompt: undefined,
      setupButton: undefined,
    };

    this.installApp = this.installApp.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  installApp() {
    console.log("Installer");

    this.state.deferredPrompt.prompt();
    // this.state.setupButton.disabled = true;
    // Wait for the user to respond to the prompt
    this.state.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("PWA setup accepted");
        // hide our user interface that shows our A2HS button
        this.state.setupButton.style.display = "none";
      } else {
        console.log("PWA setup rejected");
      }
      // this.state.deferredPrompt = null;
    });
  }

  handleButtonClick() {
    if (typeof this.state.deferredPrompt !== "undefined") {
      this.installApp();
    } else {
      navigate("/" + this.props.language + "/pwa_guide");
    }
  }

  componentDidMount() {
    if (this.state.setupButton == undefined) {
      this.state.setupButton = document.getElementById("setup_button");
    }

    if (
      !window.matchMedia("(display-mode: standalone)").matches &&
      typeof this.props.type !== "undefined" &&
      this.props.type !== "pwa_guide"
    ) {
      this.state.setupButton.style.display = "inline";
      this.state.setupButton.disabled = false;
    }

    window.addEventListener("beforeinstallprompt", (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.state.deferredPrompt = e;
      console.log("beforeinstallprompt fired");

      // // Show the setup button
      // this.state.setupButton.style.display = "inline";
      // this.state.setupButton.disabled = false;
    });

    window.addEventListener("appinstalled", (evt) => {
      console.log("appinstalled fired", evt);
      if (typeof this.props.type !== "undefined" && this.props.type === "pwa_guide") {
        history.back();
      }
    });
  }

  render() {
    const {
      siteTitle,
      currentChapter,
      currentSubChapter,
      currentH2,
      currentH3,
      chapterColor,
      sticky,
      language,
      type,
    } = this.props;

    let PWAbuttonText;
    switch (language) {
      case "da":
        PWAbuttonText = "Download ROCKINFO";
        break;
      case "sv":
        PWAbuttonText = "Ladda ner ROCKINFO";
        break;
      case "no":
        PWAbuttonText = "Last ned ROCKINFO";
        break;
      case "fi":
        PWAbuttonText = "Download ROCKINFO";
        break;
    }

    return (
      <header
        className={`header header--${sticky ? "sticky" : "fixed"} ${
          sticky ? "header--" + chapterColor : ""
        }`}
      >
        <div className="header__inner">
          <div className="header__inner-fixed">
            <h1 title={siteTitle} className="header__title">
              {typeof language !== "undefined" ? (
                <span className="header__link">
                  <Link to={`/${language}/`}>
                    <img src={logo} alt="Logo" className="header__logo" />
                  </Link>
                  <button
                    id="setup_button"
                    onClick={({ event }) => {
                      this.handleButtonClick();
                    }}
                  >
                    {PWAbuttonText}
                  </button>
                </span>
              ) : (
                <span className="header__link">
                  <img src={logo} alt="Logo" className="header__logo" />
                  <button
                    id="setup_button"
                    onClick={({ event }) => {
                      this.handleButtonClick();
                    }}
                  >
                    {PWAbuttonText}
                  </button>
                </span>
              )}
            </h1>
          </div>
          <div className="header__inner-sticky">
            <div className="breadcrumbs">
              <span className="breadcrumbs__chapter">{currentChapter}</span>
              {currentSubChapter ? ": " : ""}
              <span className="breadcrumbs__subchapter">{currentSubChapter}</span>
              <Transition
                items={currentH2}
                from={{ opacity: 0, transform: "translateY(-50%)" }}
                enter={{ delay: 100, opacity: 1, transform: "translateY(0)" }}
                leave={{ opacity: 0, visibility: "hidden", height: 0 }}
              >
                {(styles, item) =>
                  item && (
                    <animated.span className="breadcrumbs__h2" style={styles}>
                      {currentH2}
                    </animated.span>
                  )
                }
              </Transition>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
  currentChapter: PropTypes.string,
  currentSubChapter: PropTypes.string,
  currentH2: PropTypes.string,
  currentH3: PropTypes.string,
  chapterColor: PropTypes.string,
  sticky: PropTypes.bool,
  language: PropTypes.string,
  type: PropTypes.string,
};

export default Header;
